<template>
    <div>
        <div class="row my-2 mx-0" v-if="componentItemsPerPageSelect != false">
            <div class="col-sm-6 p-0 offset-sm-6">
                <div class="form-inline justify-content-sm-end">
                    <label class="mfe-2">
                        {{ componentItemsPerPageSelect.label }}:
                    </label>
                    <select
                        class="form-control"
                        @change="runPaginationChange"
                        v-model="componentItemsPerPage"
                    >
                        <option
                            v-for="(
                                item, index
                            ) in componentItemsPerPageSelect.values"
                            :key="index"
                            :value="item"
                        >
                            {{ item }}
                        </option>
                    </select>
                </div>
            </div>
        </div>
        <slot name="over-table"> </slot>
        <div
            ref="tableWrap"
            :class="[
                {
                    'table-responsive': responsive && resizable,
                },
                {
                    'table-resizable': hasItems && resizable,
                },
                'table-wrapper',
            ]"
        >
            <table
                class="table"
                :class="[
                    {
                        'table--sm': size == 'sm',
                    },
                ]"
            >
                <thead>
                    <tr>
                        <!-- aqui hay que ver lo que se renderiza por segunda vez -->
                        <th
                            :data-type="item._type"
                            v-for="(item, index) in componentFieldsActive"
                            :key="index"
                            class="position-relative pr-4"
                            :class="[
                                {
                                    'th-resizable': isItemResizable(item),
                                },
                            ]"
                        >
                            <div>
                                {{ formatFieldLabel(item) }}
                            </div>

                            <span @click="clickSortArrow(item)">
                                <CIcon
                                    v-if="item.sorter"
                                    :class="[
                                        'position-absolute',
                                        'arrow-position',
                                        {
                                            transparent:
                                                componentSorterValue.column !=
                                                item.key,
                                        },
                                    ]"
                                    :content="
                                        componentSorterValue.asc == false &&
                                        componentSorterValue.column == item.key
                                            ? $options.icons.cilArrowBottom
                                            : $options.icons.cilArrowTop
                                    "
                                />
                            </span>
                            <span
                                class="resize-handle"
                                v-if="isItemResizable(item)"
                                @mousedown="initResize"
                            ></span>
                        </th>
                    </tr>
                    <tr v-if="componentFieldsHasFilters.length > 0">
                        <th
                            v-for="(item, index) in componentFieldsActive"
                            :key="index"
                        >
                            <input
                                v-if="item.filter"
                                v-model="componentColumnFilterValue[item.key]"
                                v-on:keyup.enter="runColumnFilter"
                                v-on:change="runColumnFilter"
                                class="form-control form-control-sm"
                            />
                        </th>
                    </tr>
                </thead>
                <tbody
                    v-if="componentItems.length > 0"
                    class="position-relative"
                >
                    <template v-for="(item, index) in componentItems">
                        <tr :key="index + '-a'" :class="{ 'table-row--odd': index % 2 !== 0 }">
                            <td
                                v-for="field in componentListFieldsActive"
                                :class="getFieldClassesIfExist(field)"
                                :style="getFieldStylesIfExist(field)"
                                :key="field"
                            >
                                <slot :name="field" v-bind="{ item, index }">
                                    <slot
                                        :name="field"
                                        v-bind="{ item, index }"
                                    >
                                        {{
                                            Array.isArray(item[field]) &&
                                            item[field].length === 0
                                                ? ""
                                                : item[field]
                                        }}
                                    </slot>
                                </slot>
                            </td>
                        </tr>
                        <tr :key="index + '-b'" class="invisible" />
                        <tr
                            :key="index + '-c'"
                            class="p-0"
                            style="border: none !important"
                        >
                            <td
                                class="p-0"
                                :colspan="componentFieldsActive.length"
                                style="border: none !important"
                            >
                                <slot name="details" v-bind="{ item, index }">
                                </slot>
                            </td>
                        </tr>
                    </template>
                </tbody>
                <tbody v-else class="position-relative">
                    <tr>
                        <td :colspan="componentFieldsActive.length">
                            <slot name="no-items-view">
                                <div class="text-center my-5">
                                    <h2>No items</h2>
                                </div>
                            </slot>
                        </td>
                    </tr>
                </tbody>
            </table>
            <CElementCover v-if="componentLoading" :opacity="0.8" />
        </div>

        <slot name="under-table"> </slot>
    </div>
</template>

<script>
/**Components */

/** Mixins */
import baseMixin from "~/mixins/base.js";
/** Others */
import { cilArrowTop, cilArrowBottom } from "@coreui/icons";

export default {
    name: "CustomTable",
    mixins: [baseMixin],
    icons: {
        cilArrowTop,
        cilArrowBottom,
    },
    data() {
        return {
            componentItems: [],
            componentFields: [],
            componentLoading: false,
            componentColumnFilterValue: null,
            componentItemsPerPageSelect: false,
            componentSorterValue: {
                columns: null,
                asc: true,
            },
            componentItemsPerPage: 5,

            headerBeingResized: null,
            initClientX: null,
            initClientWidth: null,
            initTableWidth: null,
            columns: [],
            min: 50,
            columnTypeToRatioMap: {
                Integer: 100,
                Number: 130,
                Boolean: 80,
                String: 200,
                Date: 130,
                Text: 300,
            },
        };
    },
    computed: {
        componentListFields() {
            return this.componentFields.map((field) => {
                return field.key ? field.key : field;
            });
        },
        componentListFieldsActive() {
            return this.componentFieldsActive.map((field) => {
                return field.key ? field.key : field;
            });
        },
        componentFieldsHasFilters() {
            return this.componentFields.filter((field) => {
                return field.filter;
            });
        },
        componentFieldsActive() {
            return this.componentFields.filter((field) => {
                return field.hasOwnProperty("_active")
                    ? field._active == true
                    : true;
            });
        },
        hasItems() {
            return this.componentItems.length > 0;
        },
    },
    props: {
        items: {
            type: Array,
            default: () => {
                return [];
            },
        },
        fields: {
            default: () => {
                return [];
            },
        },
        responsive: {
            default: true,
        },
        loading: {
            default: false,
        },
        size: {
            default: "md",
        },
        columnFilterValue: {
            default: null,
        },

        itemsPerPageSelect: {
            type: Object | Boolean,
            default: false,
        },
        itemsPerPage: {
            type: Number,
            default: 5,
        },
        sorter: {
            default: false,
        },
        sorterValue: {
            default: () => {
                return {
                    column: null,
                    asc: true,
                };
            },
        },
        resizable: {
            default: true,
        },
    },
    watch: {
        items: {
            async handler(newValue) {
                this.componentItems = this.items;
                // this.$set(this, "componentItems", this.items);
            },
            deep: true,
        },
        fields(newValue) {
            this.componentFields = newValue;
        },
        loading(newValue) {
            this.componentLoading = newValue;
        },
        componentLoading(newValue) {
            this.$emit("update:loading", newValue);
        },

        columnFilterValue(newValue) {
            this.componentColumnFilterValue = this.copyObject(newValue);
        },

        componentSorterValue: {
            async handler(newValue) {
                // En `mounted` se copia la prop al estado interno con
                // `copyObject`, que devuelve un objeto NUEVO: el watcher (deep)
                // se disparaba aunque el valor fuera el mismo y emitia un
                // "ha cambiado el orden" que no habia ocurrido.
                //
                // Las vistas que recargan al ordenar
                // (`@update:sorter-value="updateData()"`) pedian por eso los
                // datos dos veces en cada carga, y con ellos las peticiones por
                // fila. Solo se emite cuando el valor difiere de la prop.
                const current = this.sorterValue || {};
                const next = newValue || {};
                if (
                    current.column === next.column &&
                    current.asc === next.asc
                ) {
                    return;
                }
                this.$emit("update:sorterValue", newValue);
                this.$emit("update:sorter-value", newValue);
            },
            deep: true,
        },

        itemsPerPageSelect(newValue) {
            this.componentItemsPerPageSelect =
                this.getDefaultItemsPerPageSelect(newValue);
        },

        itemsPerPage(newValue) {
            this.componentItemsPerPage = newValue;
        },

        componentItemsPerPage(newValue) {
            this.$emit("update:items-per-page", newValue);
            this.$emit("update:itemsPerPage", newValue);
        },
    },
    methods: {
        isItemResizable(item) {
            if (this.hasItems == false || this.resizable == false) {
                return false;
            }
            if (Object.hasOwnProperty.call(item, "resizable")) {
                return item.resizable;
            }
            return true;
        },
        onMouseMove(e) {
            const width = this.initClientWidth + (e.clientX - this.initClientX);
            // Update the column object with the new size value
            const column = this.columns.find(
                ({ header }) => header === this.headerBeingResized
            );
            column.size = Math.max(this.min, width) + "px"; // Enforce our minimum

            // For the other headers which don't have a set width, fix it to their computed width
            let currentTableWith = 0;
            this.columns.forEach((column) => {
                if (column.size.startsWith("minmax")) {
                    // isn't fixed yet (it would be a pixel value otherwise)
                    column.size =
                        parseInt(column.header.clientWidth, 10) + "px";
                }
                currentTableWith += parseInt(column.header.clientWidth, 10);
            });

            if (this.initTableWidth > currentTableWith) {
                let diff = this.initTableWidth - currentTableWith;
                let lastColumn = this.columns[this.columns.length - 1];
                let newSize =
                    parseInt(lastColumn.header.clientWidth, 10) + diff;
                lastColumn.size = Math.max(this.min, newSize) + "px";
            }

            /*
              Update the column sizes
              Reminder: grid-template-columns sets the width for all columns in one value
            */
            this.columns.forEach((item) => {
                item.header.style.width = item.size;
                return item;
            });
            // this.$el.querySelector("table").style.gridTemplateColumns =
            //     this.columns.map(({ header, size }) => size).join(" ");
        },
        onMouseUp(e) {
            window.removeEventListener("mousemove", this.onMouseMove);
            window.removeEventListener("mouseup", this.onMouseUp);
            this.headerBeingResized.classList.remove("header--being-resized");
            this.headerBeingResized = null;
            this.$el
                .querySelector("table")
                .classList.remove("table--being-resized");
        },
        initResize(e) {
            this.columns = [];

            let firstTr = this.$el.querySelector("tr");
            let thFromFirstTr = Array.from(firstTr.querySelectorAll("th"));
            this.columns = thFromFirstTr.map((thItem) => {
                // const min = this.columnTypeToRatioMap[thItem.dataset.type]
                //     ? this.columnTypeToRatioMap[thItem.dataset.type]
                //     : 255;
                return {
                    header: thItem,
                    size: thItem.clientWidth + "px",
                    // size: Math.max(min, thItem.clientWidth) + "px",
                    // size: `minmax(${this.min}px, ${max})`,
                };
            });

            this.$el.querySelector("table").style.tableLayout = "fixed";

            this.columns.forEach((item) => {
                item.header.style.width = item.size;
                return item;
            });

            this.headerBeingResized = e.target.parentNode;
            this.initClientX = e.pageX;
            this.initClientWidth = this.headerBeingResized.clientWidth;
            if (this.initTableWidth == null)
                this.initTableWidth =
                    this.$el.querySelector("table").clientWidth;
            // this.$el.querySelector("table").style.tableLayout = 'fixed';
            window.addEventListener("mousemove", this.onMouseMove);
            window.addEventListener("mouseup", this.onMouseUp);
            this.headerBeingResized.classList.add("header--being-resized");
            this.$el
                .querySelector("table")
                .classList.add("table--being-resized");
        },

        runColumnFilter(e) {
            this.$emit(
                "update:columnFilterValue",
                this.componentColumnFilterValue
            );
            this.$emit(
                "update:column-filter-value",
                this.componentColumnFilterValue
            );
        },
        runPaginationChange(e) {
            this.$emit("pagination-change", this.componentItemsPerPage);
        },
        getDefaultItemsPerPageSelect(value) {
            let resp = value;
            if (value == true) {
                resp = {
                    label: "Item per page",
                    values: [5, 10, 20, 50],
                    external: false,
                };
            } else if (typeof value == "object") {
                resp = {
                    label: "Item per page",
                    values: [5, 10, 20, 50],
                    external: false,
                    ...value,
                };
            } else resp = false;
            return resp;
        },

        clickSortArrow(item) {
            if (
                !(
                    "column" in this.componentSorterValue &&
                    "asc" in this.componentSorterValue
                )
            ) {
                this.componentSorterValue = {
                    column: item.key,
                    asc: true,
                };
            }
            if (item.key != this.componentSorterValue.column) {
                this.componentSorterValue.column = item.key;
                this.componentSorterValue.asc = true;
            } else {
                if (
                    item.key == this.componentSorterValue.column &&
                    this.componentSorterValue.asc == false
                ) {
                    this.componentSorterValue.column = null;
                }
                this.componentSorterValue.asc = !this.componentSorterValue.asc;
            }
        },
        getFieldByKey(key) {
            return this.componentFields.find((item) => {
                if (typeof item === "object" && item !== null) {
                    return item["key"] == key;
                }
                return item == key;
            });
        },
        getFieldClassesIfExist(key) {
            let field = this.getFieldByKey(key);
            let classes = field["_classes"];
            if (classes) return classes;
            else "";
        },
        getFieldStylesIfExist(key) {
            let field = this.getFieldByKey(key);
            let styles = field["_style"];
            if (styles) return styles;
            else "";
        },
        formatFieldLabel(item) {
            if (typeof item === "object" && item !== null) {
                return item.label != null ? item.label : item.key;
            }
            return item;
        },
    },
    async mounted() {
        this.componentItems = this.items;
        this.componentFields = this.fields;
        this.componentLoading = this.loading;
        this.componentColumnFilterValue = this.copyObject(
            this.columnFilterValue
        );

        this.componentSorterValue = this.copyObject(this.sorterValue);

        this.componentItemsPerPageSelect = this.getDefaultItemsPerPageSelect(
            this.itemsPerPageSelect
        );

        this.componentItemsPerPage = this.itemsPerPage;
    },
    async updated() {
        // if (this.hasItems > 0) {
        //     this.$el.querySelector("table").style.gridTemplateColumns =
        //         this.columns.map((column) => column.size).join(" ");
        // }
    },
};
</script>

<style scoped>
/* .table-resizable table {
    width: auto;
    -webkit-box-flex: 1;
    flex: 1;
    display: grid;
    border-collapse: collapse;
}

.table-resizable thead,
.table-resizable tbody,
.table-resizable tr {
    display: contents;
} */

.table-resizable td {
    overflow: hidden;
    white-space: nowrap;
}

.table-resizable th {
    white-space: nowrap;
}

th,
td {
    padding: 15px;
    /* overflow: hidden; */
    text-overflow: ellipsis;
}

th {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    text-align: left;
    position: relative;
}

.table thead th {
    vertical-align: middle;
}

.resize-handle {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    background: black;
    opacity: 0;
    width: 3px;
    cursor: col-resize;
}

tr:first-of-type th::before {
    content: "";
    position: absolute;
    right: 0;
    border: solid 1px;
    border-color: rgba(0, 0, 0, 0.151);
    bottom: 25%;
    height: 50%;
    border-radius: 50%;
}

tr:first-of-type th.th-resizable:hover::before {
    border-color: rgba(0, 0, 0, 0.582);
}

.table--being-resized {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

.transparent {
    opacity: 0.4;
}
.arrow-position {
    right: 5%;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
}

@media (max-width: 767.98px) {
    /* Aplicar estilos solo en dispositivos móviles */
    .table-wrapper {
        display: block;
        width: 100%;
        overflow-x: auto;
        overflow-y: visible !important;
    }
}

.table-row--odd {
    background-color: rgba(0, 0, 0, 0.04);
}
</style>
